export default {
    '登录':'登入',
    '忘记密码':'忘記密碼',
    '联系客服':'聯系客服',
    '欢迎登录':'歡迎登錄',
    '还没有账号':'還沒有賬號',
    '去注册':'去註冊',
    '首页': '首頁',
    '公益榜': '公益榜',
    '反诈': '反詐',
    '我的': '我的',
    '注册': '注册',
    '切换登录': '切換登錄',
    '有账号': '有賬號',
    '用户注册': '用戶註冊',
    '请输入账号': '請輸入賬號',
    '请输入手机号': '請輸入手機號',
    '请再次输入密码': '請再次輸入密碼',
    '请输入真实姓名': '請輸入真實姓名',
    '请输入密码': '請輸入密碼',
    '热搜榜': '熱搜榜',
    '关于我们': '關於我們',
    '我要参与': '我要參與',
    '新闻动态': '新聞動態',
    '下载': '下載',
    '联系我们': '聯繫我們',
    '字节跳动公益':'字節跳動公益',
    '我们是谁':'我們是誰',
    '新加坡': '新加坡',
    '海淀北二街10号': '海淀北二街10號',
    '9层0902室': '9層0902室',
    '抖音热榜': '抖音熱榜',
    '音乐榜': '音樂榜',
    '电影榜': '電影榜',
    '财经榜': '財經榜',
    '直播榜': '直播榜',
    '最新': '最新',
    '推荐': '推薦',
    '银行卡账号': '銀行卡賬號',
    '姓名': '姓名',
    '预留手机号': '預留手機號',
    '开户行': '開戶行',
    '提交资料': '提交資料',
    '请输入': '請輸入',
    '卡号': '卡號',
    '银行预留手机号': '銀行預留手機號',
    '当前账户余额': '當前賬戶余額',
    '请绑定提现银行卡': '請綁定提現銀行卡',
    '提现密码': '提現密碼',
    '提交申请': '提交申請',
    '温馨提示': '溫馨提示',
    '提现时间': '提現時間',
    '余额': '余額',
    '立即提现': '立即提現',
    '去充值': '去充值',
    '抖音商城': '抖音商城',
    '美好生活触手可得': '美好生活觸手可得',
    '安全中心': '安全中心',
    '财务信息请妥善保管': '財務信息請妥善保管',
    '助力记录': '助力記錄',
    '交易记录': '交易記錄',
    '金额': '金額',
    '变动时间': '變動時間',
    '点击加载更多': '點擊加載更多',
    '修改提现密码': '修改提現密碼',
    '银行卡': '銀行卡',
    '退出登录': '退出登錄',
    '请输入提现密码,新用户默认登录密码': '請輸入提現密碼,新用戶默認登錄密碼',
    '截止参与': '截止參與',
    '截止开奖': '截止開獎',
    '期': '期',
    '已捐款':'已捐款',
    '捐款次数':'捐款次數',
    '我的捐款': '我的捐款',
    '邀请好友参加':'邀請好友參加',
    '立即捐赠':'立即捐贈',
    '跳过':'跳過',
    '我已知晓':'我已知曉',
    '成就生命的美好': '成就生命的美好',
    '山里DOU是好风光': '山裡DOU是好風光',
    '依托当地特色文旅资源打造品牌，助力文旅扶贫': '依託當地特色文旅資源打造品牌，助力文旅扶貧',
    'TikTok公益基金会定制愿景与使命的目的是希望“通过提升个体的智力，体力和财力”使其能够实现自己的生命价值。':'TikTok公益基金會定制願景與使命的目的是希望“通過提升個體的智力，體力和財力”使其能够實現自己的生命價值。',
    '字节跳动医务救助基金投入':'位元組跳動醫務救助基金投入',
    'TikTok公益医务救助基金投入':'TikTok公益醫務救助基金投入',
    '抖音非遗合伙人播放':'抖音非遺合夥人播放',
    '山货上头条助销农产品':'山貨上頭條助銷農產品',
    '头条寻人找到':'頭條尋人找到',
    '医疗健康':'醫療健康',
    '字节跳动医务基金': '位元組跳動醫務基金',
    '字节跳动医务基金为抗击疫情一线医务工作者提供保障，目前基金总额为4.46亿元。':'位元組跳動醫務基金為抗擊疫情一線醫務工作者提供保障，現時基金總額為4.46億元。',
    '2020 字节跳动基金会京公网安备 11000002002068号 京ICP备12025439号-7':'2020位元組跳動基金會京公網安備11000002002068號京ICP備12025439號-7',
    '字节跳动基金会京公网安备11000002002068号': '位元組跳動基金會京公網安備11000002002068號',
    '京ICP备12025439号':'京ICP備12025439號',
    '收款银行': '收款銀行',
    '收款人账号':'收款人帳號',
    '收款人姓名':'收款人姓名',
    '红队赔率':'紅隊賠率',
    '蓝队赔率':'藍隊賠率',
}
